<template>
  <div class="pricing">
    <page-hero :title="title" :subtitle="subtitle" />
    <section
      class="font-sans container m-auto max-w-xl flex flex-col flex-wrap sm:flex-row justify-center"
    >
      <div class="w-full sm:w-1/2 lg:w-1/4 text-center py-8">
        <label for class="uppercase tracking-loose font-bold text-sm"
          >Basic Plan</label
        >
        <br />
        <span class="uppercase text-grey-dark font-light text-xs"
          >Starting at</span
        >
        <h1 for class="uppercase tracking-loose font-bold text-5xl my-2">
          $499
        </h1>
        <p class="w-full leading-normal w-1/2 text-grey-dark">
          For small businesses or single person teams who would like to
          establish and grow their brand.
        </p>
        <p class="my-2 text-grey-darker">
          <strong class="text-black pr-2">Includes</strong>
        </p>
        <p class="my-2 text-grey-darker">
          <strong class="text-black pr-2">High Speed</strong>Hosting
        </p>
        <p class="mt-2 text-grey-darker">
          <strong class="text-black pr-2">Free</strong>Domain
        </p>
        <p class="mt-2 text-grey-darker">
          <strong class="text-black pr-2">Up to 5</strong>Pages
        </p>
        <p class="mt-2 text-grey-darker">
          <strong class="text-black pr-2">Mobile</strong>Responsive
        </p>
        <p class="mt-2 text-grey-darker">
          <strong class="text-black pr-2">Regular</strong>Backups
        </p>
        <p class="mt-2 text-grey-darker">
          <strong class="text-black pr-2">Tailored</strong>Design
        </p>
        <p class="mt-2 text-grey-darker">
          <strong class="text-black pr-2">Advanced Security</strong>Updates
        </p>
        <p class="mt-2 text-grey-darker">
          <strong class="text-black pr-2">1 Branded Email</strong>Address
        </p>
        <p class="mt-2 mb-6 text-grey-darker">
          <strong class="text-black pr-2">Free</strong>SSL Certificate
        </p>
      </div>
      <div class="w-full sm:w-1/2 lg:w-1/4 text-center py-8">
        <label for class="uppercase tracking-loose font-bold text-sm"
          >Team Plan</label
        >
        <br />
        <span class="uppercase text-grey-dark font-light text-xs"
          >Starting at</span
        >
        <h1 for class="uppercase tracking-loose font-bold text-5xl my-2">
          $899
        </h1>
        <p class="w-full leading-normal w-1/2 text-grey-dark">
          For small/medium sized companies, brands or online stores etc., who
          would like to increase their visibility.
        </p>
        <p class="my-2 text-grey-darker">
          <strong class="text-black pr-2">Includes</strong>
        </p>
        <p class="my-2 text-grey-darker">
          <strong class="text-black pr-2">High Speed</strong>Hosting
        </p>
        <p class="mt-2 text-grey-darker">
          <strong class="text-black pr-2">Free</strong>Domain
        </p>
        <p class="mt-2 text-grey-darker">
          <strong class="text-black pr-2">Up to 10</strong>Pages
        </p>
        <p class="mt-2 text-grey-darker">
          <strong class="text-black pr-2">Mobile</strong>Responsive
        </p>
        <p class="mt-2 text-grey-darker">
          <strong class="text-black pr-2">Regular</strong>Backups
        </p>
        <p class="mt-2 text-grey-darker">
          <strong class="text-black pr-2">Tailored</strong>Design
        </p>
        <p class="mt-2 text-grey-darker">
          <strong class="text-black pr-2">Security</strong>Updates
        </p>
        <p class="mt-2 text-grey-darker">
          <strong class="text-black pr-2">5 Branded Email</strong>Address
        </p>
        <p class="mt-2 mb-6 text-grey-darker">
          <strong class="text-black pr-2">Free</strong>SSL Certificate
        </p>
      </div>
      <div class="w-full sm:w-1/2 lg:w-1/4 text-center py-8">
        <label for class="uppercase tracking-loose font-bold text-sm"
          >Corporate Plan</label
        >
        <br />
        <span class="uppercase text-grey-dark font-light text-xs"
          >Starting at</span
        >
        <h1 for class="uppercase tracking-loose font-bold text-5xl my-2">
          $1499
        </h1>
        <p class="w-full leading-normal w-1/2 text-grey-dark">
          For medium sized companies who would like a custom site and an upsurge
          in their online presence.
        </p>
        <p class="my-2 text-grey-darker">
          <strong class="text-black pr-2">Includes</strong>
        </p>
        <p class="my-2 text-grey-darker">
          <strong class="text-black pr-2">Dedicated High Speed</strong>Hosting
        </p>
        <p class="mt-2 text-grey-darker">
          <strong class="text-black pr-2">Free</strong>Domain
        </p>
        <p class="mt-2 text-grey-darker">
          <strong class="text-black pr-2">Up to 25</strong>Pages
        </p>
        <p class="mt-2 text-grey-darker">
          <strong class="text-black pr-2">Mobile</strong>Responsive
        </p>
        <p class="mt-2 text-grey-darker">
          <strong class="text-black pr-2">Regular</strong>Backups
        </p>
        <p class="mt-2 text-grey-darker">
          <strong class="text-black pr-2">Completely Custom Design</strong>with
          Advanced Programming
        </p>
        <p class="mt-2 text-grey-darker">
          <strong class="text-black pr-2">Security</strong>Updates
        </p>
        <p class="mt-2 text-grey-darker">
          <strong class="text-black pr-2">Branded Email</strong>Address
        </p>
        <p class="mt-2 mb-6 text-grey-darker">
          <strong class="text-black pr-2">Free</strong>SSL Certificate
        </p>
      </div>
      <div class="w-full sm:w-1/2 lg:w-1/4 text-center py-8">
        <label for class="uppercase tracking-loose font-bold text-sm"
          >Enterprise Plan</label
        >
        <br />
        <span class="uppercase text-grey-dark font-light text-xs"
          >Starting at</span
        >
        <h1 for class="uppercase tracking-loose font-bold text-5xl my-2">
          $2199
        </h1>
        <p class="w-full leading-normal w-1/2 text-grey-dark">
          For large sized companies who would like a custom site or application
          and an upsurge in their online presence.
        </p>
        <p class="my-2 text-grey-darker">
          <strong class="text-black pr-2">Includes</strong>
        </p>
        <p class="my-2 text-grey-darker">
          <strong class="text-black pr-2">Ultimate Speed and Security</strong
          >with Dedicated VPS Hosting
        </p>
        <p class="mt-2 text-grey-darker">
          <strong class="text-black pr-2">Free</strong>Domain
        </p>
        <p class="mt-2 text-grey-darker">
          <strong class="text-black pr-2">Up to 50</strong>Pages
        </p>
        <p class="mt-2 text-grey-darker">
          <strong class="text-black pr-2">Mobile</strong>Responsive
        </p>
        <p class="mt-2 text-grey-darker">
          <strong class="text-black pr-2">Regular</strong>Backups
        </p>
        <p class="mt-2 text-grey-darker">
          <strong class="text-black pr-2">Completely Custom Design</strong>with
          Advanced Programming
        </p>
        <p class="mt-2 text-grey-darker">
          <strong class="text-black pr-2">Security</strong>Updates
        </p>
        <p class="mt-2 text-grey-darker">
          <strong class="text-black pr-2">20 Branded Email</strong>Address
        </p>
        <p class="mt-2 mb-6 text-grey-darker">
          <strong class="text-black pr-2">Free</strong>SSL Certificate
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import PageHero from "@/components/PageHero";

export default {
  name: "pricing",
  components: {
    PageHero
  },
  data() {
    return {
      title: "Pricing",
      subtitle: `We work with you to understand the needs of your business and builds a complete digital products to meet those goals.`
    };
  }
};
</script>
